import { Type } from '@angular/core';
import { FilterRenderer } from './filter/filter-renderer';

export enum FilterTypes {
  Equal = 'equal',
  EqualNoCase = 'equalnocase',
  Range = 'range',
  Multi = 'multi',
  Group = 'group',
  MultiField = 'multifield',
  /* The next are a set of not yet supported filters, but eventually will be so we keep them here for reference
  Type = 'type',
  GeoDistance = 'geoDistance',
  GeoPolygon = 'geoPolygon',
  MultiOR = 'multiOR',
  MultiNotEqual = 'multiNotEqual',
  NotExist = 'notExist',
  Prefix = 'match_phrase_prefix',
  Stats = 'stats',
  Period = 'period',
  */
}

export interface Filter {
  /**
   * The value of the filter
   */
  key: string | number;
  /**
   * Header of the title
   */
  value: string;
  /**
   * criteria type: eq, or, range, multi etc
   */
  type: FilterTypes;
  /**
   * Record Attribute
   */
  field: string;

  /**
   * Lookup category source
   */
  lookupCategory?: string;
  /**
   * The selected values of the filter, can be an array, number, string etc
   */
  values?: any;

  /**
   * The selected values of the filter, can be an array, number, string etc
   */
  inputType?: string; // text, number, dropdown, slider, date
  dataType?: string;
  tooltip?: string;
  showLabel?: boolean;
  placeholder?: string;
  disabled?: boolean;
  associations?: Filter[];
  minValue?: number;
  maxValue?: number;
  group_key?: string;
  /**
   * Option to remove filter on UI, if not provided it will default to false
   */
  closeIcon?: boolean;
  /**
   * Option to hide optionMenuIcon on filter to show extra options like exclude empty, include empty, exclude selection, if not provided it will default to false
   */
  hideOptionMenuIcon?: boolean;

  /**
   * using this attribute not selectable from the list and disabled on the UI
   */
  excludeSelection?: boolean;
  /**
   * Include records with no value for this field
   */
  includeEmpty?: boolean;
  /**
   * Exclude records with no value for this field; clears filter input
   */
  excludeEmpty?: boolean;
  /**
   * using this attribute the filter is mandatory and cannot be removed from the UI
   */

  mandatory?: boolean;

  LabelRenderer?: Type<FilterRenderer>;

  groupOrder?: number | number[];

  /**
   * Stores selected option metadata (key + displayName) for multi-select / select filters.
   * Used to preserve displayName when selections have 0-count and are not in aggregations.
   * Persisted to localStorage and saved searches.
   */
  persistentSelection?: Array<{ key: string | number; displayName: string }>;

  selectItemsInGroup?: boolean; // if true, selecting this filter will also select all its associations (group members) in the listbox, even though only the representative is stored in filters[]

  compoundFilters?: IOption[];
}

export interface Aggregation {
  key: string;
  value: number;
  displayName?: string;
}
export interface Aggregations {
  [key: string]: Aggregation[];
}

export interface IOption {
  key?: any;
  value?: string;
  label?: string;
  displayName?: string;
  /** Marks an option as a 0-count disabled label (grayed out, user can still uncheck) */
  disabledLabel?: boolean;
}

export interface PriorityFilterId {
  [key: number]: { isPriority: boolean; priorityLevel?: number; order?: number };
}

export class QueryCriteria {
  type?: string; // equals | range | or
  key?: number;
  field?: string | string[]; // property.address.city
  values?: RangeValue | any; // string | number |  string[] | number[];
  dataType?: string; // text, int...
  name?: string;
  includeEmpty?: boolean;
  excludeEmpty?: boolean;
  condition?: string;
  excludeSelection?: boolean;
  typeAhead?: boolean;
}

export class RangeValue {
  eq?: any; // might not be used
  from?: any;
  to?: any;
}

export interface ISearchFilterSettings {
  title: string;
  filters: Filter[];
  sectionId?: number;
}
